import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { ToastService } from "@malirang/front-share";
import { ChildStore } from "../stores/child.store";

export const HasChildGuard: CanActivateFn = async () => {
    const childStore = inject(ChildStore);
    const toastService = inject(ToastService);

    await childStore.childFetchAll();

    const hasChild = !!childStore.selectedChild$();

    if (!hasChild) {
        toastService.info("아동을 먼저 선택해 주세요.");
    }

    return hasChild;
};
